import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import SEO from '../components/SEO';

const HERO_IMG = '/images/heritage-brass-band.jpg';

export default function EventsPage() {
  return (
    <div data-testid="events-page">
      <SEO
        title="Events"
        description="Community events by Glossop Round Table raising thousands for local charities. Glossop Bonfire & Fireworks Spectacular, Glossop Heritage Weekend, GlossFest music festival and more."
        path="/events"
        keywords={['Glossop events', 'Glossop community events', 'Glossop bonfire', 'Glossop heritage weekend', 'GlossFest', 'Glossop fireworks', 'charity events Glossop']}
      />
      <HeroSection
        image={HERO_IMG}
        title="Events"
        subtitle="Community events raising money for local charities"
        fullHeight={false}
        alt="Glossop Round Table volunteers in Heritage Weekend t-shirts posing in front of the Marple Band performing on the main stage"
        captionTag="Heritage Weekend 2026"
      />

      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-base text-[#52525B] leading-relaxed mb-16">
            Glossop & District Round Table 916 organise two large community events each year to raise money for local charities and good causes.
          </p>

          <div className="space-y-20">
            {/* Bonfire */}
            <article data-testid="events-bonfire" className="space-y-4">
              <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500]">Annual Event</span>
              <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0A0A0A]">
                Glossop Bonfire and Fireworks Spectacular
              </h2>
              <div className="space-y-4 text-base text-[#52525B] leading-relaxed">
                <p>
                  The event we are probably most renowned for is the Glossop Bonfire and Fireworks Spectacular. We first brought the event to Glossop over 50 years ago. We have held the Bonfire and Fireworks display in Manor Park, Glossop, every year apart from in 2020 which was cancelled due to covid restrictions.
                </p>
                <p>
                  It has evolved significantly since we first held the event. It now includes a Children's and Adults Fireworks Display, the Bonfire, Fair Ground rides, a DJ, local Food vendors, performances from local groups, our charity bar and so much more.
                </p>
                <p>
                  If you would like to get involved with Round Table or help marshal the event please email{' '}
                  <a href="mailto:volunteers@glossoproundtable.org" className="text-[#F0A500] hover:text-[#D99500] font-semibold transition-colors">volunteers@glossoproundtable.org</a>{' '}
                  or find us on{' '}
                  <a href="https://www.facebook.com/glossoprt/" target="_blank" rel="noopener noreferrer" className="text-[#F0A500] hover:text-[#D99500] font-semibold transition-colors">Facebook</a>.
                </p>
                <a
                  href="https://www.ticketsource.co.uk/glossop-roundtable/glossop-bonfire-spectacular-8-november-2025/e-oegapo"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="events-bonfire-tickets-link"
                  className="btn-amber inline-block"
                >
                  Get Tickets
                </a>
              </div>
            </article>

            <hr className="border-zinc-200" />

            {/* Heritage */}
            <article data-testid="events-heritage" className="space-y-4">
              <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500]">Bi-Annual Event</span>
              <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0A0A0A]">
                Glossop Heritage Weekend
              </h2>
              <div className="space-y-4 text-base text-[#52525B] leading-relaxed">
                <p>
                  In May 2020, after polling the local community, we were hoping to bring back the much anticipated Victorian Weekend, which was last put on by Gala back in May 2008. Covid 19 however had other plans for us.
                </p>
                <p>
                  We regrouped and formed a new committee and set the date for May 2022. As it hadn't been put on for 14 years we were a little sceptical of whether or not people would turn out however, our concerns were misplaced, the weekend last year was a huge success! Over the weekend we had heritage fair ground rides, a stage with heritage live acts, several steam engines, Morris dancing, a beer festival, local food vendors, market stalls and a parade. 1000s of people turned out for the entire weekend.
                </p>
                <p>
                  Due to the overwhelming preparation and planning of the Heritage Weekend, we have decided that this would be a bi-annual event running in May 29th-31st 2026, 2028 and so on.
                </p>
                <p>
                  Further details can be found at{' '}
                  <a href="https://glossopheritageweekend.org/" target="_blank" rel="noopener noreferrer" className="text-[#F0A500] hover:text-[#D99500] font-semibold transition-colors">Glossop Heritage Weekend</a>.
                </p>
                <Link
                  to="/heritage-programme"
                  data-testid="events-heritage-programme-link"
                  className="btn-amber inline-block"
                >
                  View 2026 Programme
                </Link>
              </div>
            </article>

            <hr className="border-zinc-200" />

            {/* GlossFest */}
            <article data-testid="events-glossfest" className="space-y-4">
              <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500]">Bi-Annual Event</span>
              <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0A0A0A]">
                GlossFest – Music in the Heart of Glossop
              </h2>
              <div className="space-y-4 text-base text-[#52525B] leading-relaxed">
                <p>
                  In October 2024 we met with Glossop Creative Trust to form a committee for a music festival in the heart of Glossop, Norfolk Square. Along with local bands performing on stage, we incorporated local businesses, food vendors, pubs and bars along with our legendary Charity Beer Festival.
                </p>
                <p>
                  The turnout was excellent and the weekend was exceptionally successful. This is a bi-annual event running in 2025, 2027 and so on.
                </p>
                <Link
                  to="/glossfest"
                  data-testid="events-glossfest-link"
                  className="btn-amber inline-block"
                >
                  View GlossFest
                </Link>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
}
